<svg
  class="w-full h-auto"
  width='100%'
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M16 28L2.14355 4L29.8564 4L16 28Z" fill="#FB5215"/>
</svg>
